import env from 'app/common/services/getEnvironment';
import { useMe } from 'app/pages/app/AppDataProvider/hooks/useMe';

export const WA_DEDICATED_NUMBER_ONBOARDING = 'WA_DEDICATED_NUMBER_ONBOARDING';
export const APPLE_SHARED_ACCESS = 'APPLE_SHARED_ACCESS';
export const JIM_LEAD_COLLECTION = 'JIM_LEAD_COLLECTION';
export const COMPETITIVE_BENCHMARK_V2 = 'COMPETITIVE_BENCHMARK_V2';

const PARTOO_PUSH_PREPROD_PROD_ORG_ID = 106844;

const APPLE_SHARED_ACCESS_PROD_ORGS_WHITELIST = [
    12323, // Partoo
    106844, // Partoo_Push_Preprod
    109433, // El Corte Ingles Seguros
    114699, // Unavets
    319, // Carglass FR
    109154, // Carglass ES
    121965, // Decathlon FR
    112698, // Go Electra
    114623, // Tamoil
    1130, // Carrefour IT
    139168, // Carrefour Services
    13216, // Carrefour Occasion
    106188, // Chronodrive
    111133, // Decathlon CH
    120426, // Nhood
    121967, // Centarus
    105238, // BNP Paribas
    124199, // Groupe OPNR
];

export const useFeatureFlagsValues = () => {
    const me = useMe();
    return {
        [WA_DEDICATED_NUMBER_ONBOARDING]: false,
        [APPLE_SHARED_ACCESS]: !env.isProd(),
        // !env.isProd() || (me && APPLE_SHARED_ACCESS_PROD_ORGS_WHITELIST.includes(me?.org_id)),
        [JIM_LEAD_COLLECTION]:
            !env.isProd() || (env.isProd() && me?.org_id === PARTOO_PUSH_PREPROD_PROD_ORG_ID),
    };
};

export type FeatureFlags = ReturnType<typeof useFeatureFlagsValues>;
export type FeatureFlag = keyof FeatureFlags;

export const USE_COMPLETION_ENHANCEMENTS: boolean = env.isDev();
export const USE_VERIF_FUNNEL = env.isDev() || env.isStaging();

export const USE_ORG_MANAGER: boolean = env.isDev() || env.isStaging();
